<div class="receipt">
  @for (sectionData of _receiptArray; track sectionData) {
    <div [id]="sectionData?.sectionEvidenceID" class="app-receipt-section" [ngClass]="{'border-bottom':isDivorceTransfer}"
    [sectionData]="sectionData" (editRoute)="userEdit($event)" (remove)="userRemove($event)" (noRoutingEditing)="handleNoRoutingEditing($event)"></div>
  }
</div>
<app-receipt-modal></app-receipt-modal>
